export function isLoginIdentityUser(user) {
    return typeof user === 'object' && 'id' in user && 'email' in user && !('companyCode' in user);
}
export function isExpertUser(user) {
    return typeof user === 'object' && 'id' in user && 'email' in user && 'companyCode' in user;
}
export function isInvitedUser(user) {
    return typeof user === 'object' && 'id' in user && 'invitation' in user;
}
export function isGroupReservationUser(user) {
    return typeof user === 'object' && 'id' in user && 'groupReservation' in user;
}
//# sourceMappingURL=guards.js.map